import 'bootstrap/dist/css/bootstrap.min.css';

import leakplum from "../newservice/image/leakplum.jpeg"
import drain from "../newservice/image/drainplum.jpg"
import fixer from "../newservice/image/fixureinstall.jpeg"
import pipe from "../newservice/image/piperepair.jpg"
import emergency from "../newservice/image/emergencyplum.jpg"
import heater from "../newservice/image/heaterplum.jpg"
import ptbg from '../video/plumbg.avif'
import FAQplum from './plumber/FAQPlum';
import Testimonials from './plumber/Testimonials';
import { useState,useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { FaTools, FaUsers, FaStar, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

import logo from "../newservice/image/fixureinstall.jpeg";
// import plumber1 from "../newservice/image/heaterplum.jpg";
// import plumber2 from "../newservice/image/heaterplum.jpg";
// import gallery1 from "../newservice/image/fixureinstall.jpeg";
import gallery2 from "../newservice/image/piperepair.jpg";
import gallery3 from "../newservice/image/fixureinstall.jpeg";
import bgImage from "../newservice/image/fixureinstall.jpeg";
const gallery1="https://harrogateplumber.com/wp-content/uploads/2023/07/bathroom-1.jpg";
const plumber1= "https://www.nicepng.com/png/full/413-4138963_unknown-person-png.png";
const plumber2= "https://www.kindpng.com/picc/m/52-526043_unknown-person-png-transparent-png.png";

const imgStyle = {
  backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.3)), url(${bgImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  color: 'white',
  textAlign: 'center',
  padding: '70px 20px',
};

const sectionStyle = {
  background:'#0b3d2e',
  color: '#d4af37',
  textAlign: 'center',
  padding: '10px',
  borderRadius: '8px',
  marginBottom: '1rem'
};

const services = [
  { title: 'Leak Detection & Repair', image: leakplum, features: ['Water pipe leaks', 'Ceiling and wall moisture diagnosis', 'Slab leak repair', 'Dripping faucets & hidden leaks'] },
  { title: 'Drain Cleaning & Unclogging', image: drain, features: ['Kitchen & bathroom drains', 'Toilet unclogging', 'Sewer line inspections', 'Hydro-jetting services'] },
  { title: 'Water Heater Services', image: heater, features: ['Water heater installation', 'Repairs and maintenance', 'Tankless system installation', 'Thermostat and element replacements'] },
  { title: 'Fixture Installation', image: fixer, features: ['Sinks, faucets, and toilets', 'Showerheads and bathtubs', 'Garbage disposals', 'Water-saving upgrades'] },
  { title: 'Pipe Repair & Replacement', image: pipe, features: ['Copper and PVC pipe repair', 'Re-piping services', 'Burst pipe replacement', 'Frozen pipe solutions'] },
  { title: 'Emergency Plumbing', image: emergency, features: ['24/7 plumbing services', 'Flooding and burst pipe response', 'Sewer backups', 'Immediate leak repair'] },
];

const faqs = [
  { question: 'Do you provide emergency plumbing?', answer: 'Yes, we offer 24/7 emergency plumbing services for urgent leaks, burst pipes, and more.' },
  { question: 'Are your plumbers licensed?', answer: 'All our plumbers are licensed, insured, and professionally trained.' },
  { question: 'Do you offer free estimates?', answer: 'Yes, we provide free estimates after initial inspection.' },
  { question: 'Which areas do you serve?', answer: 'We serve Your City/Region and nearby areas.' },
  { question: 'Can I book online?', answer: 'Yes, you can request a service online via our contact form or call directly.' },
];

const PlumberServices = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = (index) => setOpenIndex(openIndex === index ? null : index);

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <div>
      {/* Header */}
      {/* <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-3 shadow-sm fixed-top">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="#">
            <img src={logo} alt="Logo" width="40" className="me-2" />
            <strong>OneStopService</strong>
          </a>
          <button className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><a className="nav-link" href="#about">About</a></li>
              <li className="nav-item"><a className="nav-link" href="#services">Services</a></li>
              <li className="nav-item"><a className="nav-link" href="#team">Team</a></li>
              <li className="nav-item"><a className="nav-link" href="#gallery">Gallery</a></li>
              <li className="nav-item"><a className="nav-link" href="#faq">FAQ</a></li>
              <li className="nav-item"><a className="nav-link" href="#contact">Contact</a></li>
            </ul>
          </div>
        </div>
      </nav> */}

      <div style={{ marginTop: '80px' }}>

        
      </div>

      {/* Hero */}
      <section style={imgStyle}>
        <h1 className="display-3 fw-bold" style={{color:'#d4af37'}}><FaTools /> Reliable Plumbing Services</h1>
        <p className="lead mt-3">
          From leaky faucets to full installations, we've got your plumbing needs covered.
        </p>
        <a href="#contact" className="btn btn-lg btn-primary mt-3">Request Service</a>
      </section>

      {/* About */}
      <section id="about" className="my-5 p-4 bg-light text-dark container rounded shadow-sm">
        <h2 className="text-center mb-3" style={sectionStyle}>About OneStopService Plumbing</h2>
        <p>With over 10 years of trusted plumbing service, OneStopService provides expert residential and commercial plumbing repairs, maintenance, and installations. We pride ourselves on fast response, transparent pricing, and lasting results.</p>
      </section>

      {/* Services */}
      <section id="services" className="container my-5">
        <h2 style={sectionStyle}>🚿 Our Plumbing Services</h2>
        <div className="row">
          {services.map((service, index) => (
            <div className="col-md-6 col-lg-4 mb-4" key={index} data-aos="fade-up">
              <div className="card h-100 shadow-sm">
                <img src={service.image} className="card-img-top" alt={service.title} style={{ height: '200px', objectFit: 'cover' }} />
                <div className="card-body">
                  <h5 className="card-title">{service.title}</h5>
                  <ul className="list-unstyled">{service.features.map((item, idx) => <li key={idx}>• {item}</li>)}</ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Team */}
      <section id="team" className="container text-center my-5">
        <h2 style={sectionStyle}><FaUsers /> Our Plumbing Experts</h2>
        <div className="row justify-content-center">
          {[plumber1, plumber2].map((img, idx) => (
            <div className="col-md-4 mb-3" key={idx} data-aos="fade-up">
              <div className="card border-0 shadow-sm">
                <img src={img} className="card-img-top" alt={`Plumber ${idx + 1}`} />
                <div className="card-body">
                  <h5 className="card-title">Plumber {idx + 1}</h5>
                  <p className="text-muted">Specialist in emergency and residential plumbing</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery */}
      <section id="gallery" className="container my-5 bg-light rounded p-4 shadow-sm text-center">
        <h2 style={sectionStyle}>🔧 Plumbing Gallery</h2>
        <div className="row">
          {[gallery1, gallery2, gallery3].map((img, idx) => (
            <div className="col-md-4 mb-4" key={idx} data-aos="zoom-in">
              <img src={img} alt={`Gallery ${idx + 1}`} className="img-fluid rounded shadow" />
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="container my-5">
        <h2 style={sectionStyle}>❓ FAQs</h2>
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="card my-2" key={index}>
              <div className="card-header" style={{ cursor: 'pointer', backgroundColor: '#f1f1f1' }} onClick={() => toggleFAQ(index)}>
                <h5 className="mb-0 d-flex justify-content-between align-items-center">
                  {faq.question}
                  <span>{openIndex === index ? '−' : '+'}</span>
                </h5>
              </div>
              {openIndex === index && <div className="card-body bg-white text-dark">{faq.answer}</div>}
            </div>
          ))}
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="container my-5 text-center p-4 bg-dark text-white rounded">
        <h2><FaPhoneAlt /> Contact Us</h2>
        <p className="lead">Need help fast? Get in touch!</p>
        <p>
          <FaPhoneAlt /> <a href="tel:+919199245536" className="text-warning">+91 91992 45536</a><br />
          <FaEnvelope /> <a href="mailto:gyasuddinali0786@gmail.com" className="text-info">gyasuddinali0786@gmail.com</a>
        </p>
        <a href="/contact" className="btn btn-outline-light mt-3">Book Online</a>
      </section>
    </div>
  );
};

export default PlumberServices;
